var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgDlsSearch = function SvgDlsSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.41 42.59l-16.5-16.5C30.84 23.56 32 20.42 32 17c0-8.28-6.72-15-15-15S2 8.72 2 17c0 8.28 6.72 15 15 15 3.42 0 6.56-1.16 9.09-3.09l16.5 16.5 2.82-2.82zM6 17c0-6.07 4.93-11 11-11s11 4.93 11 11-4.93 11-11 11S6 23.07 6 17z"
  })));
};

export default __webpack_public_path__ + "static/media/DLS_Search.0b6f25bd.svg";
export { SvgDlsSearch as ReactComponent };